<template>
  <v-select
    class="small-text-field"
    :required="required"
    :value="card"
    :label="label"
    :items="cards"
    :v-model="card"
    item-value="id"
    item-name="id"
    @input="updateSelf"
    placeholder=" "
    :height="28"
    :hide-details="valid() == true && (error == null || error.length == 0)"
    :error-messages="valid() == true ? null : [valid()] "
    outlined
    dense
    style="width: 90px;"
  >
    <template v-slot:selection="{ item, index }">
      <span style="font-size: 12px !important;">{{item.last4}}</span>
    </template>
    <template v-slot:item="{ item, index }">
      <span style="font-size: 12px !important;">
        <b>{{item.brand}}</b>
        &nbsp;
        {{item.last4}}
      </span>
    </template>
  </v-select>
</template>

<script>
export default {
  name: "SelectableCardTypeInput",
  model: {
    prop: "card",
    event: "input"
  },
  props: {
    label: String,
    errorMessages: Object,
    required: { type: Boolean, default: true },
    card: String,
    cards: Array,
    enabled: Boolean,
    error: String
  },
  data() {
    return {
      menu: false
    };
  },
  mounted: function() {},
  methods: {
    valid() {
      // console.log(this.error);

      if (this.error == null) {
        return true;
      }

      return this.error;
    },
    updateSelf(card) {
      this.$emit("input", card);
    },
    focused() {
      // console.log("focused");
      this.$emit("focused");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
